module.exports = __webpack_public_path__ + "static/img/LxwlzjscY1000.2c5a0101.png";